import * as React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const RGPDPage = () => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark(
        frontmatter: { slug: { eq: "politique-de-confidentialite" } }
      ) {
        html
      }
    }
  `)
  const {
    markdownRemark: { html },
  } = data
  return (
    <Layout>
      <SEO title="Politique de confidentialité" />
      <div style={{ background: "#000000a3", padding: "15px" }}>
        <h1>Politique de confidentialité</h1>
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <Link to="/">Retour à l'accueil</Link>
      </div>
    </Layout>
  )
}
export default RGPDPage
